import { useContext, useEffect } from 'react'

import Loading from 'components/Loading'
import { DefaultsContext } from 'features/globalSetup/pages/Defaults/DefaultsContext'
import { FormContainer as GeneralForm } from './FormContainer'
import { useGetWorkspaceGeneralConfiguration } from './hooks/useGetWorkspaceGeneralConfiguration'

export const GeneralTab = (): React.JSX.Element => {
  const { general } = useContext(DefaultsContext)

  const { workspaceGeneralConfiguration: configApi } = useGetWorkspaceGeneralConfiguration()

  const { setWorkspaceGeneralConfiguration, workspaceGeneralConfiguration } = general || {}

  useEffect(() => {
    if (configApi && setWorkspaceGeneralConfiguration) {
      setWorkspaceGeneralConfiguration(configApi)
    }
  }, [setWorkspaceGeneralConfiguration, configApi])

  if (!configApi || !workspaceGeneralConfiguration) {
    return <Loading />
  } else {
    return <GeneralForm />
  }
}
